(function () {
  const initProductMarkers = (section) => {
    if (!section || !section?.classList.contains("product-markers-section")) {
      return;
    }

    const allMarkers = section.querySelectorAll(".product-markers__item");
    const mobileContainer = section.querySelector(
      ".product-markers-for-mobile"
    );
    const allMobileCards = mobileContainer.querySelectorAll(
      ".product-markers__item-inner"
    );

    const renameColorSwatchInputIds = () => {
      section
        .querySelectorAll(".product-markers__item-inner")
        .forEach((el, index) => {
          const allSwatchInputs = el.querySelectorAll("input[type='radio']");
          const allSwatchLabels = el.querySelectorAll("label.color-swatch");

          allSwatchInputs.forEach((input) => {
            const oldId = input.id;
            const oldName = input.name;
            input.id = `${oldId}-card${index}`;
            input.name = `${oldName}-card${index}`;
          });
          allSwatchLabels.forEach((label) => {
            const oldFor = label.htmlFor;
            label.htmlFor = `${oldFor}-card${index}`;
          });
        });
    };
    renameColorSwatchInputIds();

    const bindSwatchVariantChange = () => {
      section
        .querySelectorAll(".product-markers__item-inner")
        .forEach((card) => {
          const swatches = card.querySelectorAll(
            ".product-form__controls input[type='radio']"
          );
          const hiddenInput = card.querySelector("form input[name='id']");

          swatches.forEach((swatch) => {
            swatch.addEventListener("change", () => {
              const newVariantId = swatch.dataset.variantId;
              if (newVariantId && hiddenInput) {
                hiddenInput.value = newVariantId;
              }
            });
          });
        });
    };
    bindSwatchVariantChange();

    const initMobileSwatchState = () => {
      // Find the initially active mobile card
      const initiallyActiveCard = mobileContainer.querySelector(
        ".product-markers__item-inner.active"
      );
      
      if (initiallyActiveCard) {
        // Find the color swatch that should be checked based on the forced selected variant
        const swatches = initiallyActiveCard.querySelectorAll(
          ".product-form__controls input[type='radio']"
        );
        const hiddenVariantInput = initiallyActiveCard.querySelector("form input[name='id']");
        
        if (hiddenVariantInput && hiddenVariantInput.value) {
          const selectedVariantId = hiddenVariantInput.value;
          
          // Find and check the swatch that matches the selected variant
          swatches.forEach((swatch) => {
            if (swatch.dataset.variantId === selectedVariantId) {
              swatch.checked = true;
            } else {
              swatch.checked = false;
            }
          });
        }
      }
    };
    
    // Initialize mobile swatch state on page load
    initMobileSwatchState();

    const calcNewCoord = (marker) => {
      const card = marker.querySelector(".product-markers__item-inner");
      const markerRect = marker.getBoundingClientRect();

      if (!card) return;

      card.style.removeProperty("left");
      card.style.removeProperty("right");

      const cardRect = card.getBoundingClientRect();
      const screenWidth =
        document.documentElement.clientWidth || window.innerWidth;

      if (cardRect.right > screenWidth) {
        let newRight = markerRect.right - cardRect.right;
        if (card.classList.contains("product-markers__item-inner--to-right")) {
          newRight = -1 * (screenWidth - markerRect.right - 20);
        }

        card.style.left = "auto";
        card.style.right = `${newRight}px`;
      } else if (cardRect.left < 0) {
        let newLeft = markerRect.left - cardRect.left;
        if (card.classList.contains("product-markers__item-inner--to-left")) {
          newLeft = -1 * markerRect.left;
        }
        card.style.right = "auto";
        card.style.left = `${newLeft}px`;
      } else {
      }
    };

    const onSelectMarker = (marker) => {
      const index = marker.dataset.index;

      const screenWidth =
        document.documentElement.clientWidth || window.innerWidth;



      if (screenWidth >= 1300) {
        // Desktop behavior - no click action, only hover
        return;
      } else {
        // Mobile behavior
        if (marker.classList.contains("active")) {
          marker.classList.remove("active");
          allMobileCards.forEach((card) => {
            card.classList.remove("active");
          });
          return;
        }

        allMarkers.forEach((marker) => {
          marker.classList.remove("active");
        });
        marker.classList.add("active");

        allMobileCards.forEach((card) => {
          card.classList.remove("active");

          if (card.dataset.index == index) {
            card.classList.add("active");
            
            // Initialize swatch state for the newly active card
            const swatches = card.querySelectorAll(
              ".product-form__controls input[type='radio']"
            );
            const hiddenVariantInput = card.querySelector("form input[name='id']");
            
            if (hiddenVariantInput && hiddenVariantInput.value) {
              const selectedVariantId = hiddenVariantInput.value;
              
              // Find and check the swatch that matches the selected variant
              swatches.forEach((swatch) => {
                if (swatch.dataset.variantId === selectedVariantId) {
                  swatch.checked = true;
                } else {
                  swatch.checked = false;
                }
              });
            }
          }
        });
      }
    };

    allMarkers.forEach((marker) => {
      calcNewCoord(marker);

      marker.addEventListener("click", (event) => {
        if (event.target.closest(".js-color-swatches")) return;
        onSelectMarker(marker);
      });

      marker.addEventListener("mouseover", () => {
        if (marker.classList.contains("active")) {
          return;
        }

        const screenWidth =
          document.documentElement.clientWidth || window.innerWidth;
        if (screenWidth >= 990) {
          calcNewCoord(marker);
        }
      });

      marker.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          onSelectMarker(marker);
        }
      });
    });

    // Mobile: Close card when clicking outside
    document.addEventListener("click", (event) => {
      const screenWidth =
        document.documentElement.clientWidth || window.innerWidth;
      if (screenWidth >= 990) return; // Only on mobile
      
      // Check if click is outside both markers and active card
      const clickedMarker = event.target.closest(".product-markers__item");
      const clickedCard = event.target.closest(".product-markers-for-mobile .product-markers__item-inner");
      
      if (!clickedMarker && !clickedCard) {
        // Clicked outside - hide all cards
        allMarkers.forEach((marker) => {
          marker.classList.remove("active");
        });
        allMobileCards.forEach((card) => {
          card.classList.remove("active");
        });
      }
    });

    // Handle window resize to reinitialize mobile swatch state
    window.addEventListener("resize", () => {
      const screenWidth = document.documentElement.clientWidth || window.innerWidth;
      if (screenWidth < 990) {
        // We're in mobile mode, make sure the active card's swatch is properly initialized
        setTimeout(() => {
          initMobileSwatchState();
        }, 100); // Small delay to ensure resize is complete
      }
    });
  };

  const initAnimations = (section) => {
    if (
      !section ||
      !section?.classList.contains("product-markers-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const sectionContainer = section.querySelector(".product-markers");
    const imageContainer = section.querySelector(
      ".product-markers__image-container"
    );

    if (!sectionContainer || !imageContainer) return;

    ScrollTrigger.create({
      trigger: imageContainer,
      start: "50% bottom",
      end: "bottom top",
      onEnter: () => sectionContainer.classList.add("animated"),
    });
  };

  initProductMarkers(document.currentScript.parentElement);
  initAnimations(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initProductMarkers(event.target);
    initAnimations(event.target);
  });
})();
